const ITEMS = [
  ["80/20 Creation / Consumption", "/media/creation-consumption.mp4", "A young person making art at home", "bg-amber1"],
  ["Dinner shift", "/media/dinner-shift.jpg", "A young child stirring a pan of food on the stove", "bg-amber2", "50% 45%"],
  ["Chosen family", "/media/chosen-family.jpg", "Six young people and a dog at a seaside railing, watching the sunset together", "bg-amber1", "70% 50%"],
  ["Family business", "/media/family-business.jpg", "Young people running a 4 Roots Collective patty and zobo stall at an outdoor event", "bg-amber2", "50% 55%"],
];

const MEDIA = "absolute inset-0 h-full w-full object-cover grayscale-[35%] mix-blend-multiply transition-transform duration-700 group-hover:scale-105";

// Real family photos/videos from /media show in natural colour; stock images get the gold tint.
const VIDEO = "absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105";

export const Gallery = () => (
  <section className="bg-marigold text-ink" aria-label="Life together" data-testid="gallery-section">
    <div className="grid grid-cols-2 md:grid-cols-4">
      {ITEMS.map(([cap, src, alt, bg, pos], i) => (
        <figure key={cap} className={`fr-reveal group relative aspect-[3/4] overflow-hidden ${bg}`} style={{ transitionDelay: `${i * 80}ms` }} data-testid={`gallery-item-${i + 1}`}>
          {src.endsWith(".mp4") ? (
            <video poster={src.replace(".mp4", ".jpg")} aria-label={alt} autoPlay muted loop playsInline preload="auto" className={VIDEO} data-testid={`gallery-video-${i + 1}`}>
              <source src={src} type="video/mp4" />
              <source src={src.replace(".mp4", ".webm")} type="video/webm" />
            </video>
          ) : (
            <img src={src} alt={alt} loading="lazy" style={pos && { objectPosition: pos }} className={src.startsWith("/media/") ? VIDEO : MEDIA} data-testid={`gallery-image-${i + 1}`} />
          )}
          <figcaption className="absolute left-4 bottom-4 font-mono fr-lbl bg-marigold px-2 py-1">{cap}</figcaption>
        </figure>
      ))}
    </div>
  </section>
);
